import React, { useState, useEffect } from 'react';
import { UtilityFunctions } from "../utils/UtilityFunctions";
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";
import { userService, cookieService } from '../_services';
import { Link } from 'react-router-dom';
import ToastHeader from "../components/toastHeader";
import ValidationErrorToast from "../components/validationErrorToast";
import { userData } from "../utils/UserData";
import { api } from '../middleware/api';
import { END_POINTS } from '../utils/constants/endPoints';
import { Data } from '../_services/collections';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store';
import { useDispatch } from 'react-redux';

function getPostLoginDestination(user: any): string {
    const products: string[] = [];
    if (user?.isAccountsSignup) products.push('/ar');
    if (user?.isInterviewSimulatorSignup) products.push('/interview-simulator/dashboard');
    if (user?.isLegalAssistSignup) products.push('https://simulation.mploi.com/legal');
    if (user?.isHrSimulatorSignup) products.push('https://simulation.mploi.com/hr');
    if (user?.isArAffiliateSignup) products.push('/ar/affiliate/dashboard');
    if (user?.isRentChaserSignup) products.push('https://rentchaser.mploi.com');
    if (products.length >= 1) return '/app-selector';
    return STRING_CONSTANTS.navigationString.index;
}

const SignIn = (props) => {
    const dispatch = useDispatch();
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [pwdType, setPwdType] = useState("password");
    const [btnClick, setBtnClick] = useState(false);
    const resetPwd = {
        pathname: `/forgotpassword`,
        state: { email: email }
    }
    const store = !UtilityFunctions.validateEmail(email);
    const checkPwd = UtilityFunctions.isEmptyOrNullOrUndefined(password)

    const styles: { [key: string]: React.CSSProperties } = {
        container: {
            fontFamily: "'DM Sans', sans-serif",
            backgroundColor: "#F8F9FA",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
        },
        card: {
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: "40px",
            width: "100%",
            maxWidth: "480px",
            border: "1px solid #E0E0E0",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
            textAlign: "center",
        },
        backArrow: {
            position: "absolute",
            left: "0",
            top: "4px",
            color: "#555555",
            fontSize: "24px",
            cursor: "pointer",
        },
        header: {
            position: "relative",
        },
        logoChip: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#0065FF",
            borderRadius: "10px",
            padding: "10px 18px",
            marginBottom: "24px",
            cursor: "pointer",
        },
        logo: {
            height: "28px",
        },
        title: {
            fontFamily: "'Urbanist', sans-serif",
            fontWeight: 700,
            fontSize: "28px",
            lineHeight: 1.2,
            marginBottom: "8px",
            color: "#141414",
        },
        subtitle: {
            fontSize: "16px",
            color: "#555555",
            marginBottom: "32px",
        },
        formGroup: {
            marginBottom: "20px",
            position: "relative",
            textAlign: "left",
        },
        label: {
            display: 'block',
            fontWeight: 500,
            fontSize: '14px',
            color: '#242424',
            marginBottom: '8px',
        },
        input: {
            width: "100%",
            padding: "12px 45px 12px 16px",
            backgroundColor: "#F8F9FA",
            border: "1px solid #D1D1D1",
            borderRadius: "8px",
            color: "#242424",
            fontSize: "16px",
            outline: "none",
            transition: "border-color 0.3s ease, box-shadow 0.3s ease",
        },
        inputError: {
            borderColor: "#dc3545",
        },
        inputIcon: {
            position: "absolute",
            right: "15px",
            top: "42px",
            cursor: "pointer",
        },
        forgotPasswordLink: {
            display: "block",
            textAlign: "right",
            fontSize: "14px",
            color: "#0065FF",
            textDecoration: "none",
            marginTop: "-10px",
            marginBottom: "24px",
        },
        button: {
            background: "#0065FF",
            borderRadius: "8px",
            border: "none",
            boxShadow: "0px 10px 20px -10px rgba(0, 101, 255, 0.4)",
            padding: "16px",
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            color: "#FFFFFF",
            cursor: "pointer",
            width: "100%",
            transition: "all 0.3s ease",
        },
        buttonDisabled: {
            opacity: 0.6,
            cursor: "not-allowed",
        },
        footerText: {
            marginTop: "24px",
            fontSize: "14px",
            color: "#555555"
        },
        footerLink: {
            color: "#0065FF",
            fontWeight: 700,
            textDecoration: "none",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            fontSize: "14px",
        }
    };

    useEffect(() => {
        cookieService.removeAllCookies();
    }, [])
    // REGISTERS FCM TOKEN WITH THE BACKEND FOR PUSH NOTIFICATIONS
    const regDeviceToken = () => {
        api.post('device-token/', {
            "deviceType": "WEB",
            "user": `${(cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user) as Data).user.id}`,
            "token": `${cookieService.getCookie('fcm')}`
        }).then(
            // (res) => console.log(res)
        )
            .catch(
            // (e) => console.log(e)
        )
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setBtnClick(true);
        if (UtilityFunctions.isEmptyOrNullOrUndefined(email)) {
            ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_toast_email, STRING_CONSTANTS.validationString.req_email);
        }
        else if (store) {
            ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_toast_email, STRING_CONSTANTS.validationString.req_email_incorrect);
        }
        else if (checkPwd) {
            ValidationErrorToast(STRING_CONSTANTS.formLabelString.label_password, STRING_CONSTANTS.validationString.req_password);
        }
        else {
            if (!(email && password)) {
                return;
            }
            let params = {
                email: email,
                password: password,
                // source: STRING_CONSTANTS.API_PARAMS.WEB
            }

            userService.login(params)
                .then((res: any) => {
                    let response = res?.data?.user?.token?.access;
                    cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.user, res.data);
                    cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.token, response);
                    setUnreadNotificationCount(res?.data?.user?.unreadNotificationCount)
                }).then(() => {
                    api.get("category/", null)
                        .then(res => cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.jobCategories, res))
                    const userData = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);
                    props.history.push(getPostLoginDestination(userData?.user));
                    if (cookieService.getCookie('fcm')) {
                        regDeviceToken()
                    }
                })
                .catch(function (error) {
                    //debugger
                    ToastHeader(error);
                });
        }
    }
    const togglePassword = () => {
        if (pwdType === "password") {
            setPwdType("text");
            return;
        }
        setPwdType("password");
    };

    const onBoarding = {
        pathname: "/",
        state: { activeIndex: 2 }
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.header}>
                    <i className="fa fa-angle-left" style={styles.backArrow} aria-hidden="true" onClick={() => props.history.goBack()}></i>
                    <span style={styles.logoChip} onClick={() => props.history.push(onBoarding)}>
                        <img alt="MPLOI" style={styles.logo} src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
                    </span>
                </div>
                <h1 style={styles.title}>Sign in</h1>
                <p style={styles.subtitle}>Welcome back! Let’s get you signed in.</p>

                <form onSubmit={handleSubmit} noValidate>
                    <div style={styles.formGroup}>
                        <label htmlFor="floatingInput" style={styles.label}>Email Address</label>
                        <input
                            type="email"
                            id="floatingInput"
                            placeholder="Enter Email"
                            name='email'
                            style={{
                                ...styles.input,
                                ...(btnClick && store && email.length > 0 ? styles.inputError : {})
                            }}
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); setBtnClick(false); }}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label htmlFor="floatingInputpwd" style={styles.label}>Password</label>
                        <input
                            type={pwdType}
                            id="floatingInputpwd"
                            placeholder="Enter Password"
                            name='password'
                            style={{
                                ...styles.input,
                                ...(btnClick && checkPwd && password.length > 0 ? styles.inputError : {})
                            }}
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); setBtnClick(false); }}
                        />
                        <div onClick={togglePassword} style={styles.inputIcon}>
                            <img src={pwdType === "password" ? UtilityFunctions.getImageURL() + 'eyeOff.png' : UtilityFunctions.getImageURL() + 'eyeOn.png'} alt="" />
                        </div>
                    </div>

                    <Link to={resetPwd} style={styles.forgotPasswordLink}>
                        Forgot Password?
                    </Link>

                    <button
                        type='submit'
                        style={{ ...styles.button, ...((store || checkPwd) ? styles.buttonDisabled : {}) }}
                        onClick={(e) => { handleSubmit(e); }}
                    >
                        Sign In
                    </button>
                </form>

                <p style={styles.footerText}>
                    Don't have an account?{' '}
                    <button type='button' style={styles.footerLink} onClick={() => props.history.push(STRING_CONSTANTS.navigationString.signupAgents)}>
                        Signup
                    </button>
                </p>
            </div>
        </div>
    )
}
export default SignIn;
